/* eslint-disable max-len */
/* This is a generated file. If you want to change it, edit generate-exports instead. */

import activity from '@jetbrains/icons/activity.svg';
import add from '@jetbrains/icons/add.svg';
import added from '@jetbrains/icons/added.svg';
import analytics from '@jetbrains/icons/analytics.svg';
import archive from '@jetbrains/icons/archive.svg';
import artifacts from '@jetbrains/icons/artifacts.svg';
import asteriskSmall from '@jetbrains/icons/asterisk-small.svg';
import asterisk from '@jetbrains/icons/asterisk.svg';
import attachment from '@jetbrains/icons/attachment.svg';
import bell from '@jetbrains/icons/bell.svg';
import branches from '@jetbrains/icons/branches.svg';
import bug from '@jetbrains/icons/bug.svg';
import buildTypeArrow from '@jetbrains/icons/buildType-arrow.svg';
import buildTypeCompositeArrow from '@jetbrains/icons/buildType-composite-arrow.svg';
import buildTypeCompositeFillArrow from '@jetbrains/icons/buildType-composite-fill-arrow.svg';
import buildTypeCompositeFill from '@jetbrains/icons/buildType-composite-fill.svg';
import buildTypeCompositeSArrow from '@jetbrains/icons/buildType-composite-S-arrow.svg';
import buildTypeCompositeSFillArrow from '@jetbrains/icons/buildType-composite-S-fill-arrow.svg';
import buildTypeCompositeSFill from '@jetbrains/icons/buildType-composite-S-fill.svg';
import buildTypeCompositeS from '@jetbrains/icons/buildType-composite-S.svg';
import buildTypeComposite from '@jetbrains/icons/buildType-composite.svg';
import buildTypeFillArrow from '@jetbrains/icons/buildType-fill-arrow.svg';
import buildTypeFill from '@jetbrains/icons/buildType-fill.svg';
import buildTypeSArrow from '@jetbrains/icons/buildType-S-arrow.svg';
import buildTypeSFillArrow from '@jetbrains/icons/buildType-S-fill-arrow.svg';
import buildTypeSFill from '@jetbrains/icons/buildType-S-fill.svg';
import buildTypeS from '@jetbrains/icons/buildType-S.svg';
import buildType from '@jetbrains/icons/buildType.svg';
import calendar from '@jetbrains/icons/calendar.svg';
import cancelled from '@jetbrains/icons/cancelled.svg';
import caretDown from '@jetbrains/icons/caret-down.svg';
import check from '@jetbrains/icons/check.svg';
import checkmark from '@jetbrains/icons/checkmark.svg';
import chevronDown from '@jetbrains/icons/chevron-down.svg';
import chevronLeft from '@jetbrains/icons/chevron-left.svg';
import chevronRight from '@jetbrains/icons/chevron-right.svg';
import chevronUp from '@jetbrains/icons/chevron-up.svg';
import close from '@jetbrains/icons/close.svg';
import code from '@jetbrains/icons/code.svg';
import collapse from '@jetbrains/icons/collapse.svg';
import comment from '@jetbrains/icons/comment.svg';
import compare from '@jetbrains/icons/compare.svg';
import copy from '@jetbrains/icons/copy.svg';
import dice from '@jetbrains/icons/dice.svg';
import download from '@jetbrains/icons/download.svg';
import drag from '@jetbrains/icons/drag.svg';
import eMail from '@jetbrains/icons/e-mail.svg';
import emoji from '@jetbrains/icons/emoji.svg';
import exception from '@jetbrains/icons/exception.svg';
import expand from '@jetbrains/icons/expand.svg';
import experiment from '@jetbrains/icons/experiment.svg';
import file from '@jetbrains/icons/file.svg';
import fixed from '@jetbrains/icons/fixed.svg';
import folder from '@jetbrains/icons/folder.svg';
import frown from '@jetbrains/icons/frown.svg';
import gift from '@jetbrains/icons/gift.svg';
import git from '@jetbrains/icons/git.svg';
import github from '@jetbrains/icons/github.svg';
import group from '@jetbrains/icons/group.svg';
import help from '@jetbrains/icons/help.svg';
import history from '@jetbrains/icons/history.svg';
import hourglass from '@jetbrains/icons/hourglass.svg';
import ignored from '@jetbrains/icons/ignored.svg';
import info from '@jetbrains/icons/info.svg';
import investigation from '@jetbrains/icons/investigation.svg';
import link from '@jetbrains/icons/link.svg';
import mammoth from '@jetbrains/icons/mammoth.svg';
import modified from '@jetbrains/icons/modified.svg';
import moreOptions from '@jetbrains/icons/more-options.svg';
import moveToTop from '@jetbrains/icons/move-to-top.svg';
import muted from '@jetbrains/icons/muted.svg';
import newWindow from '@jetbrains/icons/new-window.svg';
import noArtifacts from '@jetbrains/icons/no-artifacts.svg';
import overtime from '@jetbrains/icons/overtime.svg';
import paused from '@jetbrains/icons/paused.svg';
import pencil from '@jetbrains/icons/pencil.svg';
import permission from '@jetbrains/icons/permission.svg';
import pinEmpty from '@jetbrains/icons/pin-empty.svg';
import pinFilled from '@jetbrains/icons/pin-filled.svg';
import prClose from '@jetbrains/icons/pr-close.svg';
import prMerged from '@jetbrains/icons/pr-merged.svg';
import prOpen from '@jetbrains/icons/pr-open.svg';
import prUnknown from '@jetbrains/icons/pr-unknown.svg';
import projectArrow from '@jetbrains/icons/project-arrow.svg';
import projectFillArrow from '@jetbrains/icons/project-fill-arrow.svg';
import projectFill from '@jetbrains/icons/project-fill.svg';
import projectSArrow from '@jetbrains/icons/project-S-arrow.svg';
import projectSFillArrow from '@jetbrains/icons/project-S-fill-arrow.svg';
import projectSFill from '@jetbrains/icons/project-S-fill.svg';
import projectS from '@jetbrains/icons/project-S.svg';
import project from '@jetbrains/icons/project.svg';
import remove from '@jetbrains/icons/remove.svg';
import removed from '@jetbrains/icons/removed.svg';
import renamed from '@jetbrains/icons/renamed.svg';
import reviewersGraph from '@jetbrains/icons/reviewers-graph.svg';
import runningStatic from '@jetbrains/icons/running-static.svg';
import search from '@jetbrains/icons/search.svg';
import services from '@jetbrains/icons/services.svg';
import settings from '@jetbrains/icons/settings.svg';
import spinner from '@jetbrains/icons/spinner.svg';
import starEmpty from '@jetbrains/icons/star-empty.svg';
import starFilled from '@jetbrains/icons/star-filled.svg';
import stop from '@jetbrains/icons/stop.svg';
import success from '@jetbrains/icons/success.svg';
import tag from '@jetbrains/icons/tag.svg';
import task from '@jetbrains/icons/task.svg';
import templateArrow from '@jetbrains/icons/template-arrow.svg';
import templateSArrow from '@jetbrains/icons/template-S-arrow.svg';
import templateS from '@jetbrains/icons/template-S.svg';
import template from '@jetbrains/icons/template.svg';
import testSuccess from '@jetbrains/icons/test-success.svg';
import time from '@jetbrains/icons/time.svg';
import torrent from '@jetbrains/icons/torrent.svg';
import trash from '@jetbrains/icons/trash.svg';
import treemap from '@jetbrains/icons/treemap.svg';
import umbrella from '@jetbrains/icons/umbrella.svg';
import unknownOs from '@jetbrains/icons/unknown-os.svg';
import unsorted from '@jetbrains/icons/unsorted.svg';
import update from '@jetbrains/icons/update.svg';
import userCancelled from '@jetbrains/icons/user-cancelled.svg';
import userDisc from '@jetbrains/icons/user-disc.svg';
import userException from '@jetbrains/icons/user-exception.svg';
import userHourglass from '@jetbrains/icons/user-hourglass.svg';
import userSpinner from '@jetbrains/icons/user-spinner.svg';
import userSuccess from '@jetbrains/icons/user-success.svg';
import userWarning from '@jetbrains/icons/user-warning.svg';
import user from '@jetbrains/icons/user.svg';
import vcsRootArrow from '@jetbrains/icons/vcs-root-arrow.svg';
import vcsRootSArrow from '@jetbrains/icons/vcs-root-S-arrow.svg';
import vcsRootS from '@jetbrains/icons/vcs-root-S.svg';
import vcsRoot from '@jetbrains/icons/vcs-root.svg';
import voteEmpty from '@jetbrains/icons/vote-empty.svg';
import voteFilled from '@jetbrains/icons/vote-filled.svg';
import warning from '@jetbrains/icons/warning.svg';

import {iconHOC} from './icon';

export const ActivityIcon = iconHOC(activity.toString(), 'ActivityIcon');
export const AddIcon = iconHOC(add.toString(), 'AddIcon');
export const AddedIcon = iconHOC(added.toString(), 'AddedIcon');
export const AnalyticsIcon = iconHOC(analytics.toString(), 'AnalyticsIcon');
export const ArchiveIcon = iconHOC(archive.toString(), 'ArchiveIcon');
export const ArtifactsIcon = iconHOC(artifacts.toString(), 'ArtifactsIcon');
export const AsteriskSmallIcon = iconHOC(asteriskSmall.toString(), 'AsteriskSmallIcon');
export const AsteriskIcon = iconHOC(asterisk.toString(), 'AsteriskIcon');
export const AttachmentIcon = iconHOC(attachment.toString(), 'AttachmentIcon');
export const BellIcon = iconHOC(bell.toString(), 'BellIcon');
export const BranchesIcon = iconHOC(branches.toString(), 'BranchesIcon');
export const BugIcon = iconHOC(bug.toString(), 'BugIcon');
export const BuildTypeArrowIcon = iconHOC(buildTypeArrow.toString(), 'BuildTypeArrowIcon');
export const BuildTypeCompositeArrowIcon = iconHOC(buildTypeCompositeArrow.toString(), 'BuildTypeCompositeArrowIcon');
export const BuildTypeCompositeFillArrowIcon = iconHOC(buildTypeCompositeFillArrow.toString(), 'BuildTypeCompositeFillArrowIcon');
export const BuildTypeCompositeFillIcon = iconHOC(buildTypeCompositeFill.toString(), 'BuildTypeCompositeFillIcon');
export const BuildTypeCompositeSArrowIcon = iconHOC(buildTypeCompositeSArrow.toString(), 'BuildTypeCompositeSArrowIcon');
export const BuildTypeCompositeSFillArrowIcon = iconHOC(buildTypeCompositeSFillArrow.toString(), 'BuildTypeCompositeSFillArrowIcon');
export const BuildTypeCompositeSFillIcon = iconHOC(buildTypeCompositeSFill.toString(), 'BuildTypeCompositeSFillIcon');
export const BuildTypeCompositeSIcon = iconHOC(buildTypeCompositeS.toString(), 'BuildTypeCompositeSIcon');
export const BuildTypeCompositeIcon = iconHOC(buildTypeComposite.toString(), 'BuildTypeCompositeIcon');
export const BuildTypeFillArrowIcon = iconHOC(buildTypeFillArrow.toString(), 'BuildTypeFillArrowIcon');
export const BuildTypeFillIcon = iconHOC(buildTypeFill.toString(), 'BuildTypeFillIcon');
export const BuildTypeSArrowIcon = iconHOC(buildTypeSArrow.toString(), 'BuildTypeSArrowIcon');
export const BuildTypeSFillArrowIcon = iconHOC(buildTypeSFillArrow.toString(), 'BuildTypeSFillArrowIcon');
export const BuildTypeSFillIcon = iconHOC(buildTypeSFill.toString(), 'BuildTypeSFillIcon');
export const BuildTypeSIcon = iconHOC(buildTypeS.toString(), 'BuildTypeSIcon');
export const BuildTypeIcon = iconHOC(buildType.toString(), 'BuildTypeIcon');
export const CalendarIcon = iconHOC(calendar.toString(), 'CalendarIcon');
export const CancelledIcon = iconHOC(cancelled.toString(), 'CancelledIcon');
export const CaretDownIcon = iconHOC(caretDown.toString(), 'CaretDownIcon');
export const CheckIcon = iconHOC(check.toString(), 'CheckIcon');
export const CheckmarkIcon = iconHOC(checkmark.toString(), 'CheckmarkIcon');
export const ChevronDownIcon = iconHOC(chevronDown.toString(), 'ChevronDownIcon');
export const ChevronLeftIcon = iconHOC(chevronLeft.toString(), 'ChevronLeftIcon');
export const ChevronRightIcon = iconHOC(chevronRight.toString(), 'ChevronRightIcon');
export const ChevronUpIcon = iconHOC(chevronUp.toString(), 'ChevronUpIcon');
export const CloseIcon = iconHOC(close.toString(), 'CloseIcon');
export const CodeIcon = iconHOC(code.toString(), 'CodeIcon');
export const CollapseIcon = iconHOC(collapse.toString(), 'CollapseIcon');
export const CommentIcon = iconHOC(comment.toString(), 'CommentIcon');
export const CompareIcon = iconHOC(compare.toString(), 'CompareIcon');
export const CopyIcon = iconHOC(copy.toString(), 'CopyIcon');
export const DiceIcon = iconHOC(dice.toString(), 'DiceIcon');
export const DownloadIcon = iconHOC(download.toString(), 'DownloadIcon');
export const DragIcon = iconHOC(drag.toString(), 'DragIcon');
export const EMailIcon = iconHOC(eMail.toString(), 'EMailIcon');
export const EmojiIcon = iconHOC(emoji.toString(), 'EmojiIcon');
export const ExceptionIcon = iconHOC(exception.toString(), 'ExceptionIcon');
export const ExpandIcon = iconHOC(expand.toString(), 'ExpandIcon');
export const ExperimentIcon = iconHOC(experiment.toString(), 'ExperimentIcon');
export const FileIcon = iconHOC(file.toString(), 'FileIcon');
export const FixedIcon = iconHOC(fixed.toString(), 'FixedIcon');
export const FolderIcon = iconHOC(folder.toString(), 'FolderIcon');
export const FrownIcon = iconHOC(frown.toString(), 'FrownIcon');
export const GiftIcon = iconHOC(gift.toString(), 'GiftIcon');
export const GitIcon = iconHOC(git.toString(), 'GitIcon');
export const GithubIcon = iconHOC(github.toString(), 'GithubIcon');
export const GroupIcon = iconHOC(group.toString(), 'GroupIcon');
export const HelpIcon = iconHOC(help.toString(), 'HelpIcon');
export const HistoryIcon = iconHOC(history.toString(), 'HistoryIcon');
export const HourglassIcon = iconHOC(hourglass.toString(), 'HourglassIcon');
export const IgnoredIcon = iconHOC(ignored.toString(), 'IgnoredIcon');
export const InfoIcon = iconHOC(info.toString(), 'InfoIcon');
export const InvestigationIcon = iconHOC(investigation.toString(), 'InvestigationIcon');
export const LinkIcon = iconHOC(link.toString(), 'LinkIcon');
export const MammothIcon = iconHOC(mammoth.toString(), 'MammothIcon');
export const ModifiedIcon = iconHOC(modified.toString(), 'ModifiedIcon');
export const MoreOptionsIcon = iconHOC(moreOptions.toString(), 'MoreOptionsIcon');
export const MoveToTopIcon = iconHOC(moveToTop.toString(), 'MoveToTopIcon');
export const MutedIcon = iconHOC(muted.toString(), 'MutedIcon');
export const NewWindowIcon = iconHOC(newWindow.toString(), 'NewWindowIcon');
export const NoArtifactsIcon = iconHOC(noArtifacts.toString(), 'NoArtifactsIcon');
export const OvertimeIcon = iconHOC(overtime.toString(), 'OvertimeIcon');
export const PausedIcon = iconHOC(paused.toString(), 'PausedIcon');
export const PencilIcon = iconHOC(pencil.toString(), 'PencilIcon');
export const PermissionIcon = iconHOC(permission.toString(), 'PermissionIcon');
export const PinEmptyIcon = iconHOC(pinEmpty.toString(), 'PinEmptyIcon');
export const PinFilledIcon = iconHOC(pinFilled.toString(), 'PinFilledIcon');
export const PrCloseIcon = iconHOC(prClose.toString(), 'PrCloseIcon');
export const PrMergedIcon = iconHOC(prMerged.toString(), 'PrMergedIcon');
export const PrOpenIcon = iconHOC(prOpen.toString(), 'PrOpenIcon');
export const PrUnknownIcon = iconHOC(prUnknown.toString(), 'PrUnknownIcon');
export const ProjectArrowIcon = iconHOC(projectArrow.toString(), 'ProjectArrowIcon');
export const ProjectFillArrowIcon = iconHOC(projectFillArrow.toString(), 'ProjectFillArrowIcon');
export const ProjectFillIcon = iconHOC(projectFill.toString(), 'ProjectFillIcon');
export const ProjectSArrowIcon = iconHOC(projectSArrow.toString(), 'ProjectSArrowIcon');
export const ProjectSFillArrowIcon = iconHOC(projectSFillArrow.toString(), 'ProjectSFillArrowIcon');
export const ProjectSFillIcon = iconHOC(projectSFill.toString(), 'ProjectSFillIcon');
export const ProjectSIcon = iconHOC(projectS.toString(), 'ProjectSIcon');
export const ProjectIcon = iconHOC(project.toString(), 'ProjectIcon');
export const RemoveIcon = iconHOC(remove.toString(), 'RemoveIcon');
export const RemovedIcon = iconHOC(removed.toString(), 'RemovedIcon');
export const RenamedIcon = iconHOC(renamed.toString(), 'RenamedIcon');
export const ReviewersGraphIcon = iconHOC(reviewersGraph.toString(), 'ReviewersGraphIcon');
export const RunningStaticIcon = iconHOC(runningStatic.toString(), 'RunningStaticIcon');
export const SearchIcon = iconHOC(search.toString(), 'SearchIcon');
export const ServicesIcon = iconHOC(services.toString(), 'ServicesIcon');
export const SettingsIcon = iconHOC(settings.toString(), 'SettingsIcon');
export const SpinnerIcon = iconHOC(spinner.toString(), 'SpinnerIcon');
export const StarEmptyIcon = iconHOC(starEmpty.toString(), 'StarEmptyIcon');
export const StarFilledIcon = iconHOC(starFilled.toString(), 'StarFilledIcon');
export const StopIcon = iconHOC(stop.toString(), 'StopIcon');
export const SuccessIcon = iconHOC(success.toString(), 'SuccessIcon');
export const TagIcon = iconHOC(tag.toString(), 'TagIcon');
export const TaskIcon = iconHOC(task.toString(), 'TaskIcon');
export const TemplateArrowIcon = iconHOC(templateArrow.toString(), 'TemplateArrowIcon');
export const TemplateSArrowIcon = iconHOC(templateSArrow.toString(), 'TemplateSArrowIcon');
export const TemplateSIcon = iconHOC(templateS.toString(), 'TemplateSIcon');
export const TemplateIcon = iconHOC(template.toString(), 'TemplateIcon');
export const TestSuccessIcon = iconHOC(testSuccess.toString(), 'TestSuccessIcon');
export const TimeIcon = iconHOC(time.toString(), 'TimeIcon');
export const TorrentIcon = iconHOC(torrent.toString(), 'TorrentIcon');
export const TrashIcon = iconHOC(trash.toString(), 'TrashIcon');
export const TreemapIcon = iconHOC(treemap.toString(), 'TreemapIcon');
export const UmbrellaIcon = iconHOC(umbrella.toString(), 'UmbrellaIcon');
export const UnknownOsIcon = iconHOC(unknownOs.toString(), 'UnknownOsIcon');
export const UnsortedIcon = iconHOC(unsorted.toString(), 'UnsortedIcon');
export const UpdateIcon = iconHOC(update.toString(), 'UpdateIcon');
export const UserCancelledIcon = iconHOC(userCancelled.toString(), 'UserCancelledIcon');
export const UserDiscIcon = iconHOC(userDisc.toString(), 'UserDiscIcon');
export const UserExceptionIcon = iconHOC(userException.toString(), 'UserExceptionIcon');
export const UserHourglassIcon = iconHOC(userHourglass.toString(), 'UserHourglassIcon');
export const UserSpinnerIcon = iconHOC(userSpinner.toString(), 'UserSpinnerIcon');
export const UserSuccessIcon = iconHOC(userSuccess.toString(), 'UserSuccessIcon');
export const UserWarningIcon = iconHOC(userWarning.toString(), 'UserWarningIcon');
export const UserIcon = iconHOC(user.toString(), 'UserIcon');
export const VcsRootArrowIcon = iconHOC(vcsRootArrow.toString(), 'VcsRootArrowIcon');
export const VcsRootSArrowIcon = iconHOC(vcsRootSArrow.toString(), 'VcsRootSArrowIcon');
export const VcsRootSIcon = iconHOC(vcsRootS.toString(), 'VcsRootSIcon');
export const VcsRootIcon = iconHOC(vcsRoot.toString(), 'VcsRootIcon');
export const VoteEmptyIcon = iconHOC(voteEmpty.toString(), 'VoteEmptyIcon');
export const VoteFilledIcon = iconHOC(voteFilled.toString(), 'VoteFilledIcon');
export const WarningIcon = iconHOC(warning.toString(), 'WarningIcon');
